import { useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";

import { Content_SAL2110_R01 } from "./Content_SAL2110_R01";
import { SearchSection_SAL2110_R01 } from "./SearchSection_SAL2110_R01";
import { useSAL2110_R01Store } from "./Store_SAL2110_R01";
import { CustomTotalTable_SAL2110_R01 } from "./CustomTotalTable_SAL2110_R01";
import { BrandTotalTable_SAL2110_R01 } from "./BrandTotalTable_SAL2110_R01";
import { ItemTotalTable_SAL2110_R01 } from "./ItemTotalTable_SAL2110_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL2110_R01Dto } from "./Dto_SAL2110_R01";

export const Container_SAL2110_R01 = () => {
	const { initData } = useSAL2110_R01Store();
	const { setMessage } = useUiuxStore();

	const customGridRef = useRef<AgGridReact<SAL2110_R01Dto>>(null);
	const brandGridRef = useRef<AgGridReact<SAL2110_R01Dto>>(null);
	const itemGridRef = useRef<AgGridReact<SAL2110_R01Dto>>(null);

	const {
		fetchData,
		handleExcelClick,
	} = Content_SAL2110_R01({
		customGridRef,
		brandGridRef,
		itemGridRef,
		setMessage,
	});

	return (
		<div className={`content-container`}>
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={undefined}
				onDeleteClick={undefined}
				onSaveClick={undefined}
				onPrintClick={undefined}
				onExcelClick={handleExcelClick}
				onInitClick={() => { initData(); }}
			/>
			<SearchSection_SAL2110_R01 />

			<div className="flex flex-1 p-[12px] gap-[8px] min-h-0">
				<div className="flex-[2] min-w-0 h-full">
					<CustomTotalTable_SAL2110_R01 gridRef={customGridRef} />
				</div>
				<div className="flex-[2] min-w-0 h-full">
					<BrandTotalTable_SAL2110_R01 gridRef={brandGridRef} />
				</div>
				<div className="flex-[6] min-w-0 h-full">
					<ItemTotalTable_SAL2110_R01 gridRef={itemGridRef} />
				</div>
			</div>
			<Message />
		</div>
	);
};
